type UpdateTaskConfig = (
  taskId: number,
  config: Record<string, unknown>
) => void;

export function syncLocalTaskConfigUpdate(args: {
  selectedTaskId: unknown;
  changedTaskId?: unknown;
  selectedTaskConfig: Record<string, unknown> | undefined;
  updateTaskConfig?: UpdateTaskConfig;
  key: string;
  value: unknown;
}): Record<string, unknown> {
  const patch = { [args.key]: args.value };
  const taskId = args.changedTaskId ?? args.selectedTaskId;
  const nextConfig = {
    ...(args.selectedTaskConfig ?? {}),
    ...(taskId === args.selectedTaskId ? patch : {}),
  };

  if (typeof taskId === 'number') {
    args.updateTaskConfig?.(taskId, patch);
  }

  return nextConfig;
}

export function syncRemoteTaskConfigUpdate(args: {
  selectedTaskId: unknown;
  changedTaskId: unknown;
  config: Record<string, unknown>;
  updateTaskConfig?: UpdateTaskConfig;
}): Record<string, unknown> | undefined {
  const nextConfig = { ...args.config };

  if (typeof args.changedTaskId === 'number') {
    args.updateTaskConfig?.(args.changedTaskId, nextConfig);
  }

  return args.changedTaskId === args.selectedTaskId ? nextConfig : undefined;
}
